import CONTRATO_GASTOS from '@/graphql/querys/administracion/contratos/gastos/contratoGastos.gql';
import AGREGAR_CONTRATO_GASTOS from '@/graphql/mutations/administracion/contratos/contrato/gastos/agregarContratoGasto.gql';
import ACTUALIZAR_CONTRATO_GASTOS from '@/graphql/mutations/administracion/contratos/contrato/gastos/actualizarContratoGasto.gql';
import REMOVER_CONTRATO_GASTO from '@/graphql/mutations/administracion/contratos/contrato/gastos/removerContratoGasto.gql';

export default {
  methods: {
    async mixRegistrarGastos() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_GASTOS,
          variables: {
            gasto: this.gasto,
          },
          update: (store, { data: { agregarContratoGasto } }) => {
            const query = {
              query: CONTRATO_GASTOS,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const { contratoGastos } = store.readQuery(query);
            const contratoGastosCopia = contratoGastos.slice();
            contratoGastosCopia.push(agregarContratoGasto);
            store.writeQuery({
              ...query,
              data: {
                contratoGastos: contratoGastosCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = true;
      this.cerrar();
    },
    async mixActualizarGastos() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_GASTOS,
          variables: {
            id: this.gastoEditar.id,
            gasto: this.gasto,
          },
          update: (store, { data: { actualizarContratoGasto } }) => {
            const query = {
              query: CONTRATO_GASTOS,
              variables: {
                idContrato: this.gastoEditar.idContrato,
              },
            };
            const { contratoGastos } = store.readQuery(query);
            const index = contratoGastos
              .findIndex(({ id }) => id === this.gastoEditar.id);
            if (index !== -1) {
              contratoGastos.splice(index, 1, actualizarContratoGasto);
            }
            store.writeQuery({
              ...query,
              data: {
                contratoGastos,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },

    async mixEliminarGasto() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_GASTO,
        variables: {
          id: this.contratoGastoEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_GASTOS,
            variables: {
              idContrato: this.contratoGastoEliminar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoGastos } = data;
          const index = contratoGastos
            .findIndex((gasto) => gasto.id === this.contratoGastoEliminar.id);
          if (index !== -1) {
            contratoGastos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
